import { MessengerBrandInline } from "./MessengerBrandIcons";
import "./LandingHeroPhone.css";
import "./LandingCreationSection.css";

export default function LandingHeroPhone() {
  return (
    <div className="landing-hero-phone" aria-hidden="true">
      <div className="landing-hero-phone__device">
        <div className="landing-hero-phone__notch" />
        <div className="landing-hero-phone__screen">
          <div className="landing-hero-phone__statusbar">
            <span>InChat</span>
            <MessengerBrandInline size={18} />
          </div>
          <div className="landing-hero-phone__chat">
            <div className="landing-create-bot">
              <div className="landing-create-bot__bubble">
                <div
                  className="landing-create-bot__poster landing-create-bot__poster--hero"
                  style={{
                    backgroundImage: `url(${process.env.PUBLIC_URL}/images/landing/onboarding-poster.svg)`,
                  }}
                  role="img"
                  aria-label="Постер видео: День 1 — адаптация"
                />
                <p>Добро пожаловать в программу адаптации</p>
                <div className="landing-create-bot__chip">▶ Видео-сцена</div>
                <div className="landing-create-bot__actions">
                  <span>Дальше по регламенту</span>
                  <span>Задать вопрос HR</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <p className="landing-hero-phone__caption">
        Сотрудник проходит программу прямо в мессенджере
      </p>
    </div>
  );
}
